import { apiFetch } from './client.ts';

export interface ActiveWork {
  id: string;
  systemId: string;
  systemName: string;
  kind: string;
  startedAt: string;
  completesAt: string | null;
}

export const fetchActiveWork = () => apiFetch<{ items: ActiveWork[] }>('/constructions/active');
